import { createRoute, redirect } from '@tanstack/react-router';
import { RoutesMap } from '@Router/router.types';
import { UboOnboardingIntro } from '@Pages/uboOnboarding/UboOnboardingIntro';
import { routesModel } from '@Router/router.consts';
import { beforeLoadGeneral } from '@Router/middleware';
import { ValidatePhone } from '@Pages/uboOnboarding/UboValidatePhone';
import { UboIdVerificationPage } from '@Pages/uboOnboarding/UboIdVerificationPage';
import { UboCreatePassword } from '@Pages/uboOnboarding/UboCreatePassword';
import { UboDocVPage } from '@Pages/uboOnboarding/UboDocVPage';
import { useBoundStore } from '@Store/index';
import { rootRoute } from './rootRoute';

const guardUboRoute = () => {
  const { secondaryCustomerId } = useBoundStore.getState();
  if (!secondaryCustomerId) {
    throw redirect({ to: routesModel[RoutesMap.WELCOME].path });
  }
};

const UboOnboardingIntroRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.UBO_ONBOARDING_INTRO].path,
  beforeLoad: () => {
    guardUboRoute();
    beforeLoadGeneral({
      page: RoutesMap.UBO_ONBOARDING_INTRO,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: true,
    });
  },
  component: () => <UboOnboardingIntro />,
});

const UboOnboardingValidatePhoneRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.UBO_ONBOARDING_VALIDATE_PHONE].path,
  beforeLoad: () => {
    guardUboRoute();
    beforeLoadGeneral({
      page: RoutesMap.UBO_ONBOARDING_VALIDATE_PHONE,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: true,
    });
  },
  component: () => <ValidatePhone />,
});

const UboIdVerificationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.UBO_ONBOARDING_ID_VERIFICATION].path,
  beforeLoad: () => {
    guardUboRoute();
    beforeLoadGeneral({
      page: RoutesMap.UBO_ONBOARDING_ID_VERIFICATION,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: true,
    });
  },
  component: () => <UboIdVerificationPage />,
});

const UboOnboardingCreatePasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.UBO_ONBOARDING_CREATE_PASSWORD].path,
  beforeLoad: () => {
    guardUboRoute();
    beforeLoadGeneral({
      page: RoutesMap.UBO_ONBOARDING_CREATE_PASSWORD,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: true,
    });
  },
  component: () => <UboCreatePassword />,
});

const UboOnboardingDocVRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.UBO_ONBOARDING_DOCV].path,
  beforeLoad: () => {
    guardUboRoute();
    beforeLoadGeneral({
      page: RoutesMap.UBO_ONBOARDING_DOCV,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: true,
    });
  },
  component: () => <UboDocVPage />,
});

export const uboOnboardingRoutes = [
  UboOnboardingIntroRoute,
  UboOnboardingValidatePhoneRoute,
  UboIdVerificationRoute,
  UboOnboardingCreatePasswordRoute,
  UboOnboardingDocVRoute,
];
